import React, { useState } from 'react';
import { Button, Typography, List, Card } from 'antd';
import { EllipsisOutlined, DownOutlined, UpOutlined, FacebookFilled } from '@ant-design/icons';
import './Stepper.css';

const { Text } = Typography;

export const DonationReview = ({ next, prev, platform, donationOptions }) => {

    const [dataSubmitted, setDataSubmitted] = useState(false);
    const [showVideoHistory, setShowVideoHistory] = useState(false);
    const [showLikeHistory, setShowLikeHistory] = useState(false);
    const [showSearchHistory, setShowSearchHistory] = useState(false);
    const [showShareHistory, setShowShareHistory] = useState(false);
    const [showSessionHistory, setShowSessionHistory] = useState(false);
    const [showAppSettings, setShowAppSettings] = useState(false);
    const [showComments, setShowComments] = useState(false);
    const [showFavouriteVideos, setShowFavouriteVideos] = useState(false);
    const [showFavouriteSounds, setShowFavouriteSounds] = useState(false);
    const [showFavouriteHashtags, setShowFavouriteHashtags] = useState(false);
    const [showFollowing, setShowFollowing] = useState(false);
    const [showFollowers, setShowFollowers] = useState(false);
    const [showAdsData, setShowAdsData] = useState(false);
    const [showAdsAndTopics, setShowAdsAndTopics] = useState(false);
    const [showAdsAndBusinesses, setShowAdsAndBusinesses] = useState(false);
    const [showYourTopics, setShowYourTopics] = useState(false);
    const [showAppsAndWebsites, setShowAppsAndWebsites] = useState(false);
    const [showRecentSearches, setShowRecentSearches] = useState(false);
    const [showLinkHistory, setShowLinkHistory] = useState(false);
    const [showSubscriptions, setShowSubscriptions] = useState(false);
    const [showStoryInteractions, setShowStoryInteractions] = useState(false);
    const [showSaved, setShowSaved] = useState(false);
    const [showLikes, setShowLikes] = useState(false);
    const [showCommentsInstagram, setShowCommentsInstagram] = useState(false);

    const topText = 'It is important that you understand exactly what you are donating. Below, we have provided sample data that shows the form of your donation. This example has been tailored to the donation options you selected. Note, that the data shown in this screen are not real and are used only for informational purposes.'

    const tiktokDonationSummary = [
        {
            title: "Video Viewing History",
            hide: false,
            data: [
                {
                    data: [
                        {
                            title: "Video Link",
                            description: "https://www.tiktokv.com/share/video/12345/"
                        },
                        {
                            title: "Date",
                            description: "2021-09-16 15:26:29"
                        }
                    ]
                }, {
                    data: [
                        {
                            title: "Video Link",
                            description: "https://www.tiktokv.com/share/video/56789/"
                        },
                        {
                            title: "Date",
                            description: "2021-09-16 23:44:13"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showVideoHistory,
            setShowList: setShowVideoHistory
        },
        {
            title: "Like History",
            hide: !donationOptions.LikeHistory,
            data: [
                {
                    data: [
                        {
                            title: "Video Link",
                            description: "https://www.tiktokv.com/share/video/12345/"
                        },
                        {
                            title: "Date",
                            description: "2021-09-16 15:27:14"
                        }
                    ],
                }, {
                    data: [
                        {
                            title: "Video Link",
                            description: "https://www.tiktokv.com/share/video/56789/"
                        },
                        {
                            title: "Date",
                            description: "2021-09-16 21:07:35"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showLikeHistory,
            setShowList: setShowLikeHistory
        },
        {
            title: "Search History",
            hide: !donationOptions.SearchHistory,
            data: [
                {
                    data: [
                        {
                            title: "Search Term",
                            description: "tennis"
                        },
                        {
                            title: "Date",
                            description: "2021-08-11 13:47:37"
                        }
                    ]
                },
                {
                    data: [
                        {
                            title: "Search Term",
                            description: "Hades Town"
                        },
                        {
                            title: "Date",
                            description: "2021-08-11 54:20:02"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showSearchHistory,
            setShowList: setShowSearchHistory
        },
        {
            title: "Share History",
            hide: !donationOptions.ShareHistory,
            data: [
                {
                    data: [
                        {
                            title: "Shared content",
                            description: "video"
                        },
                        {
                            title: "Link",
                            description: "https://www.tiktokv.com/share/video/12345/"
                        },
                        {
                            title: "Method",
                            description: "Messenger"
                        },
                        {
                            title: "Date",
                            description: "2021-09-13 06:23:05"
                        }
                    ]
                },
                {
                    data: [
                        {
                            title: "Shared content",
                            description: "user"
                        },
                        {
                            title: "Link",
                            description: "https://vm.tiktok.com/abcde/"
                        },
                        {
                            title: "Method",
                            description: "Email"
                        },
                        {
                            title: "Date",
                            description: "2021-01-17 12:53:14"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showShareHistory,
            setShowList: setShowShareHistory
        },
        {
            title: "Session Times",
            hide: !donationOptions.ShareHistory,
            data: [
                {
                    data: [
                        {
                            title: "Date",
                            description: "2021-09-16 14:31:57"
                        }
                    ]
                },
                {
                    data: [
                        {
                            title: "Date",
                            description: "2021-01-17 12:50:00"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showSessionHistory,
            setShowList: setShowSessionHistory
        },
        {
            title: "App Settings",
            hide: !donationOptions.TikTokAppSettings,
            data: [
                {
                    data: [
                        {
                            title: "Ads Based on Data Received from Partners",
                            description: "On"
                        },
                        {
                            title: "Ads From Third-party Ad Networks",
                            description: "On"
                        },
                        {
                            title: "Allow DownLoad",
                            description: "Default"
                        },
                        {
                            title: "Allow Others to Find Me",
                            description: "Default"
                        },
                        {
                            title: "Filter Comments",
                            description: "Default"
                        },
                        {
                            title: "Interests",
                            description: "Comedy, Music"
                        },
                        {
                            title: "Language",
                            description: "English"
                        },
                        {
                            title: "Personalized Ads",
                            description: "Enabled"
                        },
                        {
                            title: "Private Account",
                            description: "Disabled"
                        },
                        {
                            title: "Video Language Preference",
                            description: "English"
                        },
                        {
                            title: "Who Can Duet With Me",
                            description: "No One"
                        },
                        {
                            title: "Who Can React to Me",
                            description: "Default"
                        },
                        {
                            title: "Who Can Send Me Messages",
                            description: "Friends"
                        },
                        {
                            title: "Who Can See Videos I Liked",
                            description: "Default"
                        }
                    ]
                }
            ],
            showEllipses: false,
            showList: showAppSettings,
            setShowList: setShowAppSettings
        },
        {
            title: "Comments",
            hide: !(donationOptions.Comments && donationOptions.CommentText),
            data: [
                {
                    data: [
                        {
                            title: "Comment Text",
                            description: "Aww! So cute <3<3"
                        },
                        {
                            title: "Date",
                            description: "2021-09-16 15:15:18"
                        }
                    ],
                },
                {
                    data: [
                        {
                            title: "Comment Text",
                            description: "I AM SO GLAD OTHER PEOPLE STILL LOVE THIS SHOW"
                        },
                        {
                            title: "Date",
                            description: "2021-01-20 06:15:27"
                        }
                    ],
                }
            ],
            showEllipses: true,
            showList: showComments,
            setShowList: setShowComments
        },
        {
            title: "Comments",
            hide: !(donationOptions.Comments && !donationOptions.CommentText),
            data: [
                {
                    data: [
                        {
                            title: "Comment Text",
                            description: "[redacted]"
                        },
                        {
                            title: "Date",
                            description: "2021-09-16 15:15:18"
                        }
                    ],
                },
                {
                    data: [
                        {
                            title: "Comment Text",
                            description: "[redacted]"
                        },
                        {
                            title: "Date",
                            description: "2021-01-20 06:15:27"
                        }
                    ],
                }
            ],
            showEllipses: true,
            showList: showComments,
            setShowList: setShowComments
        },
        {
            title: "Favourite Videos",
            hide: !donationOptions.TikTokFavourites,
            data: [
                {
                    data: [
                        {
                            title: "Video Link",
                            description: "https://www.tiktokv.com/share/video/12345/"
                        },
                        {
                            title: "Date",
                            description: "2021-01-20 06:23:37"
                        }
                    ]
                }, {
                    data: [
                        {
                            title: "Video Link",
                            description: "https://www.tiktokv.com/share/video/56789/"
                        },
                        {
                            title: "Date",
                            description: "2021-01-20 06:23:15"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showFavouriteVideos,
            setShowList: setShowFavouriteVideos
        },
        {
            title: "Favourite Sounds",
            hide: !donationOptions.TikTokFavourites,
            data: [
                {
                    data: [
                        {
                            title: "Sound Link",
                            description: "https://www.tiktokv.com/share/video/12343/"
                        },
                        {
                            title: "Date",
                            description: "2021-02-21 15:02:57"
                        }
                    ]
                }, {
                    data: [
                        {
                            title: "Sound Link",
                            description: "https://www.tiktokv.com/share/video/56789/"
                        },
                        {
                            title: "Date",
                            description: "2021-01-20 06:22:46"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showFavouriteSounds,
            setShowList: setShowFavouriteSounds
        },
        {
            title: "Favourite Hashtags",
            hide: !donationOptions.TikTokFavourites,
            data: [
                {
                    data: [
                        {
                            title: "Hashtag Link",
                            description: "https://www.tiktokv.com/share/video/12363/"
                        },
                        {
                            title: "Date",
                            description: "2021-01-17 13:50:39"
                        }
                    ]
                }, {
                    data: [
                        {
                            title: "Hashtag Link",
                            description: "https://www.tiktokv.com/share/video/56789/"
                        },
                        {
                            title: "Date",
                            description: "2021-01-17 12:50:00"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showFavouriteHashtags,
            setShowList: setShowFavouriteHashtags
        },
        {
            title: "Following",
            hide: !donationOptions.TikTokFollowing,
            data: [
                {
                    data: [
                        {
                            title: "Username",
                            description: "mpi-sws"
                        },
                        {
                            title: "Date",
                            description: "2021-09-16 05:57:26"
                        }
                    ]
                }, {
                    data: [
                        {
                            title: "Username",
                            description: "mpi-inf"
                        },
                        {
                            title: "Date",
                            description: "2021-01-17 12:49:07"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showFollowing,
            setShowList: setShowFollowing
        },
        {
            title: "Followers",
            hide: !donationOptions.TikTokFollowers,
            data: [
                {
                    data: [
                        {
                            title: "Username",
                            description: "mpi-sws"
                        },
                        {
                            title: "Date",
                            description: "2021-01-20 06:24:03"
                        }
                    ]
                }, {
                    data: [
                        {
                            title: "Username",
                            description: "mpi-inf"
                        },
                        {
                            title: "Date",
                            description: "2021-01-20 06:23:08"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showFollowers,
            setShowList: setShowFollowers
        },
        {
            title: "Ads and Data",
            hide: !donationOptions.AdData,
            data: [
                {
                    data: [
                        {
                            title: "Ads Based On Data Received From Partners (Data Partners)",
                            description: "Data Collection Inc."
                        },
                        {
                            title: "Ads Based On Data Received From Partners (Advertiser List)",
                            description: "Music Streaming Ltd, BetterBurgers Norway"
                        },
                        {
                            title: "Usage Data From Third-Party Apps And Websites",
                            description: "???"
                        }
                    ]
                }
            ],
            showEllipses: false,
            showList: showAdsData,
            setShowList: setShowAdsData
        }
    ];

    const youtubeDonationSummary = [
        {
            title: "Video Viewing History",
            hide: false,
            data: [
                {
                    data: [
                        {
                            title: "Video Name",
                            description: "More Fun Knitting Stitches"
                        },
                        {
                            title: "Video Link",
                            description: "https://www.youtube.com/watch?v\u1234abcd"
                        },
                        {
                            title: "Channel Name",
                            description: "Knittin' Kitten"
                        },
                        {
                            title: "Channel Link",
                            description: "https://www.youtube.com/channel/xyz789"
                        },
                        {
                            title: "Time",
                            description: "2021-09-16 15:26:29"
                        }
                    ]
                }, {
                    data: [
                        {
                            title: "Video Name",
                            description: "What your dog is saying to you"
                        },
                        {
                            title: "Video Link",
                            description: "https://www.youtube.com/watch?v\u5678qwert"
                        },
                        {
                            title: "Channel Name",
                            description: "rolo2323"
                        },
                        {
                            title: "Channel Link",
                            description: "https://www.youtube.com/channel/asdf5432"
                        },
                        {
                            title: "Time",
                            description: "2021-09-16 15:26:29"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showVideoHistory,
            setShowList: setShowVideoHistory
        },
        {
            title: "Like History",
            hide: !donationOptions.LikeHistory,
            data: [
                {
                    data: [
                        {
                            title: "Video ID",
                            description: "abcde12345"
                        },
                        {
                            title: "Time",
                            description: "2021-09-16 15:27:14"
                        }
                    ],
                }, {
                    data: [
                        {
                            title: "Video ID",
                            description: "vwxyz67890"
                        },
                        {
                            title: "Date",
                            description: "2021-09-16 21:07:35"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showLikeHistory,
            setShowList: setShowLikeHistory
        },
        {
            title: "Search History",
            hide: !donationOptions.SearchHistory,
            data: [
                {
                    data: [
                        {
                            title: "Search Term",
                            description: "Searched for tennis"
                        },
                        {
                            title: "Search Results Link",
                            description: "https://www.youtube.com/results?search_query\u003dtennis"
                        },
                        {
                            title: "Date",
                            description: "2021-08-11 13:47:37"
                        }
                    ]
                },
                {
                    data: [
                        {
                            title: "Search Term",
                            description: "Searched for Hades Town"
                        },
                        {
                            title: "Search Results Link",
                            description: "https://www.youtube.com/results?search_query\u003dHades+Town"
                        },
                        {
                            title: "Date",
                            description: "2021-08-11 54:20:02"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showSearchHistory,
            setShowList: setShowSearchHistory
        },
        {
            title: "Comments",
            hide: !(donationOptions.Comments && donationOptions.CommentText),
            data: [
                {
                    data: [
                        {
                            title: "Comment Text",
                            description: "Aww! So cute <3<3"
                        },
                        {
                            title: "Date",
                            description: "2021-09-16 15:15:18"
                        }
                    ],
                },
                {
                    data: [
                        {
                            title: "Comment Text",
                            description: "I AM SO GLAD OTHER PEOPLE STILL LOVE THIS SHOW"
                        },
                        {
                            title: "Date",
                            description: "2021-01-20 06:15:27"
                        }
                    ],
                }
            ],
            showEllipses: true,
            showList: showComments,
            setShowList: setShowComments
        },
        {
            title: "Comments",
            hide: !(donationOptions.Comments && !donationOptions.CommentText),
            data: [
                {
                    data: [
                        {
                            title: "Comment Text",
                            description: "[redacted]"
                        },
                        {
                            title: "Date",
                            description: "2021-09-16 15:15:18"
                        }
                    ],
                },
                {
                    data: [
                        {
                            title: "Comment Text",
                            description: "[redacted]"
                        },
                        {
                            title: "Date",
                            description: "2021-01-20 06:15:27"
                        }
                    ],
                }
            ],
            showEllipses: true,
            showList: showComments,
            setShowList: setShowComments
        },
        {
            title: "Subscriptions",
            hide: !donationOptions.YouTubeSubscriptions,
            data: [
                {
                    data: [
                        {
                            title: "Channel ID",
                            description: "12345abcde67890qwert"
                        },
                        {
                            title: "Link",
                            description: "http://www.youtube.com/channel/12345abcde67890qwert"
                        }
                    ]
                }, {
                    data: [
                        {
                            title: "Channel ID",
                            description: "67890uvwxy12345poiuy"
                        },
                        {
                            title: "Link",
                            description: "http://www.youtube.com/channel/67890uvwxy12345poiuy"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showFollowing,
            setShowList: setShowFollowing
        }
    ];

    const instagramDonationSummary = [
        {
            title: "Ads and Topics",
            hide: false,
            data: [
                {
                    data: [
                        {
                            title: "Author",
                            description: "ABC"
                        },
                        {
                            title: "Time",
                            description: "1600000000"
                        }
                    ]
                }, {
                    data: [
                        {
                            title: "Author",
                            description: "XYZ"
                        },
                        {
                            title: "Time",
                            description: "1700000000"
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showAdsAndTopics,
            setShowList: setShowAdsAndTopics,
        }, {
            title: "Ads and Businesses",
            hide: !donationOptions.InstagramAdsAndBusinesses,
            data: [
                {
                    data: [
                        {
                            title: "advertiser_name",
                            description: "ABC",
                        },
                    ]
                }, {
                    data: [
                        {
                            title: "advertiser_name",
                            description: "XYZ",
                        },
                    ]
                }
            ],
            showEllipses: true,
            showList: showAdsAndBusinesses,
            setShowList: setShowAdsAndBusinesses,            
        }, {
            title: "Your Topics",
            hide: !donationOptions.InstagramYourTopics,
            data: [
                {
                    data: [
                        {
                            title: "Name",
                            description: "Soccer",
                        },
                    ]
                }, {
                    data: [
                        {
                            title: "Name",
                            description: "Fish",
                        },
                    ]
                }
            ],
            showEllipses: true,
            showList: showYourTopics,
            setShowList: setShowYourTopics,
        }, {
            title: "Apps and Websites",
            hide: !donationOptions.InstagramAppsAndWebsites,
            data: [
                {
                    data: [
                        {
                            title: "Name",
                            description: "abc.com",
                        },
                        {
                            title: "Timestamp",
                            description: "1600000000",
                        },
                    ]
                }, {
                    data: [
                        {
                            title: "Name",
                            description: "xyz.com",
                        },
                        {
                            title: "Timestamp",
                            description: "1600000000",
                        },                        
                    ]
                }
            ],
            showEllipses: true,
            showList: showAppsAndWebsites,
            setShowList: setShowAppsAndWebsites,
        }, {
            title: "Recent Searches",
            hide: !donationOptions.InstagramRecentSearches,
            data: [
                {
                    data: [
                        {
                            title: "Search",
                            description: "abc",
                        },
                        {
                            title: "Time",
                            description: "1600000000",
                        },
                    ]
                }, {
                    data: [
                        {
                            title: "Search",
                            description: "xyz",
                        },
                        {
                            title: "Time",
                            description: "1600000000",
                        },                        
                    ]
                }
            ],
            showEllipses: true,
            showList: showRecentSearches,
            setShowList: setShowRecentSearches,
        }, {
            title: "Link History",
            hide: !donationOptions.InstagramLinkHistory,
            data: [
                {
                    data: [
                        {
                            title: "Link",
                            description: "abc.com",
                        },
                        {
                            title: "Time",
                            description: "1600000000",
                        },
                    ]
                }, {
                    data: [
                        {
                            title: "Link",
                            description: "xyz.com",
                        },
                        {
                            title: "Time",
                            description: "1600000000",
                        },                        
                    ]
                }
            ],
            showEllipses: true,
            showList: showLinkHistory,
            setShowList: setShowLinkHistory,
        }, {
            title: "Subscriptions",
            hide: !donationOptions.InstagramSubscriptions,
            data: [
                {
                    data: [
                        {
                            title: "href",
                            description: "abc",
                        },
                        {
                            title: "timestamp",
                            description: "1600000000",
                        },
                    ]
                },
            ],
            showEllipses: true,
            showList: showSubscriptions,
            setShowList: setShowSubscriptions,
        }, {
            title: "Story Interactions",
            hide: !donationOptions.InstagramStoryInteractions,
            data: [
                {
                    data: [
                        {
                            title: "Title",
                            description: "abc",
                        },
                        {
                            title: "Timestamp",
                            description: "1600000000",
                        },
                    ]
                },
            ],
            showEllipses: true,
            showList: showStoryInteractions,
            setShowList: setShowStoryInteractions,
        }, {
            title: "Saved",
            hide: !donationOptions.InstagramSaved,
            data: [
                {
                    data: [
                        {
                            title: "title",
                            description: "ABC",
                        },
                        {
                            title: "href",
                            description: "https://www.instagram.com/p/1234/",
                        },
                        {
                            title: "timestamp",
                            description: "1600000000",
                        },
                    ]
                },
            ],
            showEllipses: true,
            showList: showSaved,
            setShowList: setShowSaved,
        }, {
            title: "Likes",
            hide: !donationOptions.InstagramLikes,
            data: [
                {
                    data: [
                        {
                            title: "title",
                            description: "ABC",
                        },
                        {
                            title: "href",
                            description: "https://www.instagram.com/p/1234/",
                        },
                        {
                            title: "timestamp",
                            description: "1600000000",
                        },
                    ]
                },
            ],
            showEllipses: true,
            showList: showLikes,
            setShowList: setShowLikes,
        },  {
            title: "Comments",
            hide: !donationOptions.InstagramComments,
            data: [
                {
                    data: [
                        {
                            title: "Comment",
                            description: "[redacted]",
                        },
                        {
                            title: "Media Owner",
                            description: "ABC",
                        },
                        {
                            title: "Time",
                            description: "1600000000",
                        },
                    ]
                },
            ],
            showEllipses: true,
            showList: showCommentsInstagram,
            setShowList: setShowCommentsInstagram,
        },
    ];

    function SummaryListItem({ title, description }) {
        return (
            <div><Text strong>{title}:</Text> {description}<br></br></div>
        );
    };

    function SummaryItem({ title, data, hide, showEllipses, showList, setShowList }) {
        return (
            <List.Item hidden={hide}>
                <List.Item.Meta
                    title={
                        <div>
                            {title}
                            <Button
                                type="text"
                                onClick={() => {
                                    setShowList(!showList)
                                }}
                                icon={showList ? <UpOutlined /> : <DownOutlined />}
                            />
                        </div>}
                    description={
                        <div>
                            <List
                                bordered
                                dataSource={data}
                                className="SummaryItem"
                                renderItem={item => (
                                    <List.Item hidden={!showList}>
                                        <List.Item.Meta
                                            description={
                                                item.data.map((listItem) => (
                                                    <SummaryListItem {...listItem} />
                                                ))}
                                        />
                                    </List.Item>
                                )}
                            />
                            <EllipsisOutlined className="ellipses" hidden={!showEllipses || !showList} />
                        </div>} />
            </List.Item>
        )
    }

    return (
        <div>
            <div hidden={dataSubmitted}>
                <div className="Text">
                    <Card style={{ marginBottom: "8px" }}>
                        {topText}
                    </Card>
                    <Card className="standardCard">
                        <List >
                            {(platform === "tiktok") ?
                            tiktokDonationSummary.map((item) => (
                                <SummaryItem {...item} />
                            )) : (platform === 'youtube') ?
                            youtubeDonationSummary.map((item) => (
                                <SummaryItem {...item} />
                            )) :
                            instagramDonationSummary.map((item) => (
                                <SummaryItem {...item} />
                            ))}
                        </List>
                    </Card>
                </div>
            </div>
            <div style={{ marginTop: "1em" }}>
                <Button
                    className="RightMargin"
                    onClick={prev}>
                    Previous
                </Button>
                <Button
                    type="primary"
                    onClick={next}>
                    Next
                </Button>
            </div>
        </div>
    )
};

export default DonationReview;